import { AiFillBook, AiFillHome } from "react-icons/ai";
import {
  MdGroup,
  MdContacts,
  MdSchool,
  MdFeedback,
  MdOutlineHelp,
} from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";

import { create_UUID } from "helper/uuid";

export const CollegeStudentSidePanel = [
  {
    id: create_UUID(),
    name: "Home",
    path: "/college-student/dashboard",
    icon: <AiFillHome />,
  },
  {
    id: create_UUID(),
    name: "Interview courses",
    path: "/college-student/interview-courses",
    icon: <AiFillBook />,
  },
  {
    id: create_UUID(),
    path: "/college-student/practice-interview",
    name: "Practice Interview",
    icon: <MdGroup />,
  },
  {
    id: create_UUID(),
    path: "/college-student/my-interview",
    name: "Interview Reports",
    icon: <MdContacts />,
  },
  // {
  //   id: create_UUID(),
  //   path: "/college-student/my-goals",
  //   name: "My Goals",
  //   icon: <MdSchool />,
  // },
  {
    id: create_UUID(),
    path: "/college-student/profile",
    name: "My Profile",
    icon: <BsFillPersonFill />,
  },
  {
    id: create_UUID(),
    path: "/college-student/support-feedback",
    name: "Support & Feedback",
    icon: <MdFeedback />,
  },
  // {
  //   id: create_UUID(),
  //   path: "/college-student/help",
  //   name: "Help & Documentation",
  //   icon: <MdOutlineHelp />,
  // },
];
